import { render, staticRenderFns } from "./sidebar_reviewers_inputs.vue?vue&type=template&id=ed3c81fa"
import script from "./sidebar_reviewers_inputs.vue?vue&type=script&lang=js"
export * from "./sidebar_reviewers_inputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports